import React from 'react';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { GridContainer, TableHeaderRow } from '../styled';
import { AcademicYearTableCardProps } from '../types/AcademicYearTypes';
import { dataGridSx } from '../../common/styled/DataGrid';
import Icons from '../../../components/icons';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';

const AcademicYearTableCard: React.FC<AcademicYearTableCardProps> = ({
  rows,
  columns,
  isLoading,
  onAdd
}) => {
  return (
    <PageWrapper>
      <TableHeaderRow>
        <Button variant='contained' onClick={onAdd} disabled={isLoading}>
          <Icons.PlusWhite style={{ marginRight: '6px' }} /> Add Academic Year
          Dates
        </Button>
      </TableHeaderRow>
      <GridContainer>
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
          pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
          sx={dataGridSx(pallet)}
          loading={isLoading}
        />
      </GridContainer>
    </PageWrapper>
  );
};

export default AcademicYearTableCard;
